/**
 * @TODO COLORS CHECK
 */export default{primary:'#303f9f'};